import React from "react";
import { useCampaign } from "../../context/CampaignContext";
import "./ErrorBanner.css";

export function ErrorBanner() {
  const { error, retry } = useCampaign();

  return null;

  // eslint-disable-next-line
  if (!error) {
    return null;
  }

  return (
    <div className="error-banner" role="alert">
      <p className="error-banner__message">{error}</p>
      <button className="error-banner__retry" type="button" onClick={retry}>
        Tentar novamente
      </button>
    </div>
  );
}
